<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>建店专员工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 统计卡片区 -->
    <div class="statistics-row">
      <el-card v-for="item in statistics.platforms" :key="item.platform" class="stat-card" shadow="hover">
        <div class="stat-card-header">
          <img :src="getPlatformIcon(item.platform)" class="platform-icon" />
          <span class="platform-name">{{ item.platform }}</span>
        </div>
        <div class="stat-card-body">
          <div class="stat-item">
            <span class="stat-value uncompleted">{{ item.uncompleted }}</span>
            <span class="stat-label">未完成</span>
          </div>
          <div class="stat-item">
            <span class="stat-value completed">{{ item.completed }}</span>
            <span class="stat-label">已完成</span>
          </div>
        </div>
      </el-card>
      <el-card class="stat-card stat-card-operator" shadow="hover">
        <div class="stat-card-header">
          <i class="el-icon-user" style="font-size: 24px; color: #409eff;"></i>
          <span class="platform-name">分配运营</span>
        </div>
        <div class="stat-card-body">
          <div class="stat-item">
            <span class="stat-value uncompleted">{{ statistics.assignOperator.uncompleted }}</span>
            <span class="stat-label">未完成</span>
          </div>
          <div class="stat-item">
            <span class="stat-value completed">{{ statistics.assignOperator.completed }}</span>
            <span class="stat-label">已完成</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- Tabs 列表区 -->
    <el-card class="box-card" style="margin-top: 20px;">
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange">
        <!-- 待完成列表 -->
        <el-tab-pane label="待完成" name="todo">
          <div class="search-bar">
            <el-form :model="todoQuery" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键字">
                <el-input
                  v-model="todoQuery.keyword"
                  placeholder="项目名称/客户名称"
                  clearable
                  @clear="getTodoList"
                  @keyup.enter.native="getTodoList"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="建店专员" v-if="isAdminView">
                <el-select v-model="todoQuery.accountCreatorId" placeholder="请选择" clearable style="width: 150px;" @change="getTodoList" filterable>
                  <el-option v-for="item in accountCreatorList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getTodoList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="todoList" border stripe v-loading="todoLoading">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column label="项目名称" min-width="200">
              <template slot-scope="scope">
                <div class="text-title">{{ scope.row.projectName || '-' }}</div>
                <div class="text-detail">{{ scope.row.customerName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="signerName" label="签约人" width="80">
              <template slot-scope="scope">{{ scope.row.signerName || '-' }}</template>
            </el-table-column>
            <el-table-column label="建店专员" width="90">
              <template slot-scope="scope">{{ scope.row.accountCreateNode?.assigneeName || '-' }}</template>
            </el-table-column>
            <el-table-column label="账号信息" min-width="360">
              <template slot-scope="scope">
                <div class="text-detail">
                  <el-tag size="mini" type="warning">美团</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.meituanName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.meituanId || '--' }}</span>
                </div>
                <div class="text-detail">
                  <el-tag size="mini" type="primary">淘宝</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.taobaoName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.taobaoId || '--' }}</span>
                </div>
                <div class="text-detail">
                  <el-tag size="mini" type="danger">京东</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.jdName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.jdId || '--' }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="账号创建" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.accountCreateNode?.status === 'COMPLETED' ? 'success' : 'danger'" size="mini">
                  {{ scope.row.accountCreateNode?.status === 'COMPLETED' ? '已完成' : '待完成' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="分配运营" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.assignOperatorNode?.status === 'COMPLETED' ? 'success' : 'danger'" size="mini">
                  {{ scope.row.assignOperatorNode?.status === 'COMPLETED' ? '已完成' : '待完成' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="320" fixed="right">
              <template slot-scope="scope">
                <el-button type="info" size="mini" plain @click="showDataCollect(scope.row)">建店资料</el-button>
                <el-button type="warning" size="mini" @click="showAccountDialog(scope.row)">填写账号</el-button>
                <el-button
                  :disabled="scope.row.accountCreateNode?.status === 'COMPLETED'"
                  type="success"
                  size="mini"
                  @click="handleCompleteAccount(scope.row)">提交完成</el-button>
                <el-tooltip
                  :disabled="!scope.row.storeOpened"
                  content="门店已开业，请在店铺管理中修改运营师"
                  placement="top">
                  <span>
                    <el-button
                      style="margin-left: 10px;"
                      type="primary"
                      size="mini"
                      :disabled="scope.row.storeOpened"
                      @click="showAssignOperatorDialog(scope.row)">
                      {{ scope.row.assignOperatorNode?.status === 'COMPLETED' ? '修改运营' : '分配运营' }}
                    </el-button>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleTodoSizeChange"
            @current-change="handleTodoCurrentChange"
            :current-page="todoQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="todoQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="todoTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已完成列表 -->
        <el-tab-pane label="已完成" name="completed">
          <div class="search-bar">
            <el-form :model="completedQuery" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键字">
                <el-input
                  v-model="completedQuery.keyword"
                  placeholder="项目名称/客户名称"
                  clearable
                  @clear="getCompletedList"
                  @keyup.enter.native="getCompletedList"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="建店专员" v-if="isAdminView">
                <el-select v-model="completedQuery.accountCreatorId" placeholder="请选择" clearable style="width: 150px;" @change="getCompletedList" filterable>
                  <el-option v-for="item in accountCreatorList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="完成日期">
                <el-date-picker
                  v-model="completedQuery.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getCompletedList"
                  style="width: 240px;">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getCompletedList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="completedList" border stripe v-loading="completedLoading">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column label="项目名称" min-width="140">
              <template slot-scope="scope">
                <div class="text-title">{{ scope.row.projectName || '-' }}</div>
                <div class="text-detail">{{ scope.row.customerName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="建店专员" width="80">
              <template slot-scope="scope">{{ scope.row.accountCreateNode?.assigneeName || '-' }}</template>
            </el-table-column>
            <el-table-column label="账号信息" min-width="360">
              <template slot-scope="scope">
                <div class="text-detail">
                  <el-tag size="mini" type="warning">美团</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.meituanName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.meituanId || '--' }}</span>
                </div>
                <div class="text-detail">
                  <el-tag size="mini" type="primary">淘宝</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.taobaoName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.taobaoId || '--' }}</span>
                </div>
                <div class="text-detail">
                  <el-tag size="mini" type="danger">京东</el-tag>
                  <span style="margin-left:20px"> {{ scope.row.accountCreateNode?.data?.jdName || '--' }} </span>
                  <span style="margin-left:20px"> ID：{{ scope.row.accountCreateNode?.data?.jdId || '--' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="I阶运营师" width="90">
              <template slot-scope="scope">
                {{ scope.row.assignOperatorNode?.data?.employeeName || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="完成时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.assignOperatorNode?.completedAt | date }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240" fixed="right">
              <template slot-scope="scope">
                <el-button type="info" size="mini" plain @click="showDataCollect(scope.row)">建店资料</el-button>
                <el-button type="warning" size="mini" @click="showAccountDialog(scope.row)">填写账号</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleCompletedSizeChange"
            @current-change="handleCompletedCurrentChange"
            :current-page="completedQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="completedQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="completedTotal">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 账号创建弹窗 -->
    <el-dialog title="填写账号信息" :visible.sync="accountDialogVisible" width="700px" :close-on-click-modal="false">
      <div class="account-tip">请至少填写一个平台（美团、淘宝闪购、京东）的门店名称和门店ID</div>
      <div class="account-form">
        <div class="account-section" v-for="platform in accountPlatforms" :key="platform.key">
          <div class="account-section-header">
            <img :src="getPlatformIcon(platform.label)" class="platform-icon-sm" />
            <span>{{ platform.label }}</span>
            <span v-if="platform.required" class="required-tag">必填</span>
            <span v-else class="optional-tag">选填</span>
            <el-button type="text" size="mini" class="fill-project-name-btn" @click="fillProjectName(platform.nameKey)">使用项目名</el-button>
          </div>
          <el-form :model="accountForm" :inline="true" size="small" label-width="50px">
            <el-form-item label="名称" :required="platform.required">
              <el-input v-model="accountForm[platform.nameKey]" placeholder="门店名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="ID" :required="platform.required">
              <el-input v-model="accountForm[platform.idKey]" placeholder="门店ID"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="accountLoading" @click="saveAccountInfo(false)">保存</el-button>
        <el-button
          v-if="currentAccountRow && currentAccountRow.accountCreateNode?.status === 'IN_PROGRESS'"
          type="success"
          :loading="accountLoading"
          @click="saveAccountInfo(true)">提交完成</el-button>
      </span>
    </el-dialog>

    <!-- 分配运营弹窗 -->
    <el-dialog :title="assignDialogTitle" :visible.sync="assignDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="assignForm" ref="assignFormRef" :rules="assignRules" size="small" label-width="100px">
        <el-form-item label="项目名称">
          <span>{{ currentAssignRow?.projectName || '-' }}</span>
        </el-form-item>
        <el-form-item label="I阶运营师" prop="employeeId">
          <el-select v-model="assignForm.employeeId" placeholder="请选择运营师" filterable style="width: 100%" @change="onOperatorChange">
            <el-option v-for="item in operatorList" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="assignLoading" @click="submitAssignOperator">确定</el-button>
      </span>
    </el-dialog>

    <!-- 建店资料弹窗（可修改地址定位） -->
    <el-dialog title="建店资料" :visible.sync="dataCollectDialogVisible" width="80%" @opened="addEditableMap" @closed="removeMap" :close-on-click-modal="false">
      <div v-if="dataCollectData">
        <el-row :gutter="20">
          <el-col :span="14">
            <!-- 第一行：地址定位（可编辑） -->
            <div class="compact-section editable">
              <div class="compact-title"><i class="el-icon-location-outline"></i> 地址定位 <span class="edit-tag">可编辑</span></div>
              <div class="compact-row">
                <el-input v-model="addressEditForm.storeAddress" size="mini" placeholder="门店地址" style="width: 70%"></el-input>
                <el-button type="primary" size="mini" @click="autoLocateForEdit">定位</el-button>
              </div>
              <div class="compact-row coords" v-if="addressEditForm.province">
                <span>{{ addressEditForm.province }} {{ addressEditForm.city }} {{ addressEditForm.district }}</span>
              </div>
              <div class="compact-row">
                <div class="compact-item"><span class="label">经度：</span><span class="coords-text">{{ addressEditForm.lng?.toFixed(6) || '-' }}</span></div>
                <div class="compact-item"><span class="label">纬度：</span><span class="coords-text">{{ addressEditForm.lat?.toFixed(6) || '-' }}</span></div>
              </div>
            </div>

            <!-- 第二行：项目信息 + 法人信息 -->
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="compact-section">
                  <div class="compact-title"><i class="el-icon-document"></i> 项目信息</div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">项目：</span><span>{{ dataCollectData.projectName || '-' }}</span></div>
                  </div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">客户：</span><span>{{ dataCollectData.customerName || '-' }}</span></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="compact-section">
                  <div class="compact-title"><i class="el-icon-user"></i> 法人信息</div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">姓名：</span><span>{{ dataCollectData.legalPersonName || '-' }}</span></div>
                  </div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">身份证：</span><span>{{ dataCollectData.legalPersonId || '-' }}</span></div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <!-- 第三行：银行账户 + 店铺联系 -->
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="compact-section">
                  <div class="compact-title"><i class="el-icon-bank-card"></i> 银行账户</div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">开户行：</span><span>{{ dataCollectData.bankName || '-' }}</span></div>
                  </div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">卡号：</span><span>{{ dataCollectData.bankAccount || '-' }}</span></div>
                  </div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">手机：</span><span>{{ dataCollectData.bankPhone || '-' }}</span></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="compact-section">
                  <div class="compact-title"><i class="el-icon-phone-outline"></i> 店铺联系</div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">号码：</span><span>{{ dataCollectData.storePhone || '-' }}</span></div>
                  </div>
                  <div class="compact-row">
                    <div class="compact-item"><span class="label">备注：</span><span>{{ dataCollectData.remark || '-' }}</span></div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <!-- 第四行：图片 -->
            <div class="compact-section" v-if="dataCollectData.images && dataCollectData.images.length > 0">
              <div class="compact-title">
                <i class="el-icon-picture-outline"></i> 图片
                <span class="img-count">{{ dataCollectData.images.length }}张</span>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-download"
                  @click="handleDownloadImages"
                  :loading="downloadLoading"
                  style="margin-left: 10px;">
                  打包下载
                </el-button>
              </div>
              <div class="compact-images">
                <el-image
                  v-for="(img, idx) in dataCollectData.images"
                  :key="idx"
                  :src="base + img"
                  :preview-src-list="dataCollectData.images.map(i => base + i)"
                  fit="cover"
                  class="compact-img">
                </el-image>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <!-- 位置信息显示 -->
            <div class="map-info" v-if="addressEditForm.province">
              {{ addressEditForm.province }}{{ addressEditForm.city }}{{ addressEditForm.district }}
              | {{ addressEditForm.lat?.toFixed(6) }}, {{ addressEditForm.lng?.toFixed(6) }}
            </div>
            <div id="jiandian-map-container" class="map-container"></div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer">
        <el-button @click="dataCollectDialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="addressEditLoading" @click="saveAddressEdit">保存地址定位</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChoujianMap from '@/utility/choujianMap'
import { readLevel } from '@/utility/permissions'

export default {
  name: 'Jiandian',
  data () {
    return {
      // 统计数据
      statistics: {
        platforms: [],
        assignOperator: { total: 0, completed: 0, uncompleted: 0 }
      },

      // 当前Tab
      activeTab: 'todo',

      // 是否管理员视角
      isAdminView: false,

      // 建店专员列表（管理员筛选用）
      accountCreatorList: [],

      // 待完成列表
      todoQuery: {
        keyword: '',
        accountCreatorId: '',
        page: 1,
        pageSize: 20
      },
      todoList: [],
      todoTotal: 0,
      todoLoading: false,

      // 已完成列表
      completedQuery: {
        keyword: '',
        accountCreatorId: '',
        dateArray: [],
        page: 1,
        pageSize: 20
      },
      completedList: [],
      completedTotal: 0,
      completedLoading: false,

      // 账号创建弹窗
      accountDialogVisible: false,
      accountLoading: false,
      currentAccountRow: null,
      accountForm: {
        meituanName: '',
        meituanId: '',
        taobaoName: '',
        taobaoId: '',
        jdName: '',
        jdId: ''
      },
      accountPlatforms: [
        { key: 'meituan', label: '美团', nameKey: 'meituanName', idKey: 'meituanId', required: false },
        { key: 'taobao', label: '淘宝闪购', nameKey: 'taobaoName', idKey: 'taobaoId', required: false },
        { key: 'jd', label: '京东', nameKey: 'jdName', idKey: 'jdId', required: false }
      ],

      // 分配运营弹窗
      assignDialogVisible: false,
      assignLoading: false,
      currentAssignRow: null,
      operatorList: [],
      assignForm: {
        employeeId: '',
        employeeName: ''
      },
      assignRules: {
        employeeId: [{ required: true, message: '请选择运营师', trigger: 'change' }]
      },

      // 建店资料弹窗
      dataCollectDialogVisible: false,
      dataCollectData: null,
      currentDataCollectInstanceId: null, // 当前查看的流程实例ID（用于保存）
      addressEditForm: {
        storeAddress: '',
        lat: 0,
        lng: 0,
        province: '',
        city: '',
        district: ''
      },
      addressEditLoading: false,
      downloadLoading: false,

      // 通用
      base: '',
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },

      // 地图
      map: null,
      script: null,
      scriptLoading: null
    }
  },
  computed: {
    // 分配运营弹窗标题：已完成时为「修改运营」，否则为「分配运营」
    assignDialogTitle () {
      return this.currentAssignRow?.assignOperatorNode?.status === 'COMPLETED' ? '修改运营' : '分配运营'
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    this.checkAdminView()
    this.getStatistics()
    this.getTodoList()
    this.loadScript()
  },
  destroyed () {
    this.unloadScript()
  },
  methods: {
    // 判断是否管理员视角
    checkAdminView () {
      const level = readLevel()
      const department = window.sessionStorage.getItem('department') || ''
      const job = window.sessionStorage.getItem('job') || ''
      const isAdmin = level <= 1
      const isDirector = department.match(/^运营部门/) && job === '总监'
      const isSupervisorMaster = department.match(/^运营部门-督导部/) && job === '督导主管'
      this.isAdminView = isAdmin || isDirector || isSupervisorMaster
      if (this.isAdminView) {
        this.getAccountCreatorList()
      }
    },

    // 获取建店专员列表
    async getAccountCreatorList () {
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', {
          params: { role: 'accountCreator' }
        })
        if (res.meta.status === 200) {
          this.accountCreatorList = res.data || []
        }
      } catch (error) {
        console.error('获取建店专员列表失败:', error)
      }
    },

    // 获取平台图标
    getPlatformIcon (platform) {
      const iconMap = {
        美团: require('@/assets/meituan.png'),
        淘宝闪购: require('@/assets/shangou.png'),
        京东: require('@/assets/jd.png')
      }
      return iconMap[platform] || ''
    },

    // ==================== 统计 ====================
    async getStatistics () {
      try {
        const params = {}
        if (this.todoQuery.accountCreatorId) {
          params.accountCreatorId = this.todoQuery.accountCreatorId
        }
        const { data: res } = await this.$http.get('process/accountCreator/statistics', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.statistics = res.data
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },

    // ==================== Tab 切换 ====================
    handleTabChange (tab) {
      if (tab.name === 'todo') {
        this.getTodoList()
      } else {
        this.getCompletedList()
      }
    },

    // ==================== 待完成列表 ====================
    async getTodoList () {
      this.todoLoading = true
      this.getStatistics()
      try {
        const params = {
          keyword: this.todoQuery.keyword,
          accountCreatorId: this.todoQuery.accountCreatorId,
          page: this.todoQuery.page,
          pageSize: this.todoQuery.pageSize
        }
        const { data: res } = await this.$http.get('process/accountCreator/todo', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.todoList = res.data.list || []
        this.todoTotal = res.data.total || 0
      } catch (error) {
        console.error('获取待办任务失败:', error)
      } finally {
        this.todoLoading = false
      }
    },

    handleTodoSizeChange (val) {
      this.todoQuery.pageSize = val
      this.getTodoList()
    },
    handleTodoCurrentChange (val) {
      this.todoQuery.page = val
      this.getTodoList()
    },

    // ==================== 已完成列表 ====================
    async getCompletedList () {
      this.completedLoading = true
      try {
        const params = {
          keyword: this.completedQuery.keyword,
          accountCreatorId: this.completedQuery.accountCreatorId,
          page: this.completedQuery.page,
          pageSize: this.completedQuery.pageSize
        }
        if (this.completedQuery.dateArray && this.completedQuery.dateArray.length === 2) {
          params.startDate = this.completedQuery.dateArray[0]
          params.endDate = this.completedQuery.dateArray[1]
        }
        const { data: res } = await this.$http.get('process/accountCreator/completed', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.completedList = res.data.list || []
        this.completedTotal = res.data.total || 0
      } catch (error) {
        console.error('获取已完成任务失败:', error)
      } finally {
        this.completedLoading = false
      }
    },

    handleCompletedSizeChange (val) {
      this.completedQuery.pageSize = val
      this.getCompletedList()
    },
    handleCompletedCurrentChange (val) {
      this.completedQuery.page = val
      this.getCompletedList()
    },

    // ==================== 账号创建弹窗 ====================
    showAccountDialog (row) {
      this.currentAccountRow = row
      const data = row.accountCreateNode?.data || {}
      this.accountForm = {
        meituanName: data.meituanName || '',
        meituanId: data.meituanId || '',
        taobaoName: data.taobaoName || '',
        taobaoId: data.taobaoId || '',
        jdName: data.jdName || '',
        jdId: data.jdId || ''
      }
      this.accountDialogVisible = true
    },

    async saveAccountInfo (isComplete) {
      const form = this.accountForm
      // 校验：保存和提交完成均要求至少填写一个平台（name + id）
      // （避免保存空数据后 _syncStorePlatforms 删除已建的平台记录）
      const hasMeituan = form.meituanId && form.meituanName
      const hasTaobao = form.taobaoId && form.taobaoName
      const hasJd = form.jdId && form.jdName
      if (!hasMeituan && !hasTaobao && !hasJd) {
        return this.$message.warning('请至少填写一个平台（美团、淘宝闪购、京东）的门店名称和门店ID')
      }

      this.accountLoading = true
      try {
        const instanceId = this.currentAccountRow.accountCreateNode?.instanceId
        const action = isComplete ? 'complete' : 'update'
        const { data: res } = await this.$http.post(`process/instances/${instanceId}/execute`, {
          nodeCode: 'ACCOUNT_CREATE',
          action,
          data: form
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(isComplete ? '提交完成' : '保存成功')
        this.accountDialogVisible = false
        if (this.activeTab === 'completed') {
          this.getCompletedList()
        } else {
          this.getTodoList()
        }
        this.getStatistics()
      } catch (error) {
        console.error('保存账号信息失败:', error)
        this.$message.error('操作失败')
      } finally {
        this.accountLoading = false
      }
    },

    // 提交完成（快捷）
    async handleCompleteAccount (row) {
      const data = row.accountCreateNode?.data || {}
      const hasMeituan = data.meituanId && data.meituanName
      const hasTaobao = data.taobaoId && data.taobaoName
      const hasJd = data.jdId && data.jdName
      if (!hasMeituan && !hasTaobao && !hasJd) {
        return this.$message.warning('请先填写至少一个平台（美团、淘宝闪购、京东）的门店名称和门店ID')
      }
      const confirm = await this.$confirm('确定完成账号创建任务吗？', '提示', { type: 'warning' }).catch(() => {})
      if (confirm !== 'confirm') return

      try {
        const instanceId = row.accountCreateNode?.instanceId
        const { data: res } = await this.$http.post(`process/instances/${instanceId}/execute`, {
          nodeCode: 'ACCOUNT_CREATE',
          action: 'complete',
          data: {
            meituanId: data.meituanId,
            meituanName: data.meituanName,
            taobaoId: data.taobaoId || '',
            taobaoName: data.taobaoName || '',
            jdId: data.jdId || '',
            jdName: data.jdName || ''
          }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('提交完成')
        this.getTodoList()
        this.getStatistics()
      } catch (error) {
        console.error('操作失败:', error)
      }
    },

    // 使用项目名填充门店名称
    fillProjectName (nameKey) {
      const projectName = this.currentAccountRow?.projectName || ''
      if (!projectName) {
        return this.$message.warning('项目名称为空')
      }
      this.$set(this.accountForm, nameKey, projectName)
    },

    // ==================== 分配运营弹窗 ====================
    async showAssignOperatorDialog (row) {
      this.currentAssignRow = row

      // 回显已分配的运营师（已完成节点支持二次修改）
      const assigned = row.assignOperatorNode?.data
      this.assignForm = {
        employeeId: assigned?.employeeId || '',
        employeeName: assigned?.employeeName || ''
      }
      this.assignDialogVisible = true

      // 获取运营师列表
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', {
          params: { role: 'level1Operator' }
        })
        if (res.meta.status === 200) {
          this.operatorList = res.data || []
        }
      } catch (error) {
        console.error('获取运营师列表失败:', error)
      }
    },

    onOperatorChange (employeeId) {
      const emp = this.operatorList.find(e => e._id === employeeId)
      this.assignForm.employeeId = employeeId
      this.assignForm.employeeName = emp?.name || ''
    },

    async submitAssignOperator () {
      const valid = await this.$refs.assignFormRef.validate().catch(() => false)
      if (!valid) return

      this.assignLoading = true
      try {
        const instanceId = this.currentAssignRow.assignOperatorNode?.instanceId
        if (!instanceId) return
        // 已完成节点走专用接口二次分配（只送 employeeId，姓名由服务端解析），未完成走 complete
        const isReassign = this.currentAssignRow.assignOperatorNode?.status === 'COMPLETED'
        const url = isReassign
          ? `process/instances/${instanceId}/reassign-operator`
          : `process/instances/${instanceId}/execute`
        const body = isReassign
          ? { employeeId: this.assignForm.employeeId }
          : { nodeCode: 'ASSIGN_OPERATOR', action: 'complete', data: this.assignForm }
        const { data: res } = await this.$http.post(url, body)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(isReassign ? '修改运营成功' : '分配运营成功')
        this.assignDialogVisible = false
        this.getTodoList()
        this.getStatistics()
      } catch (error) {
        console.error('分配运营失败:', error)
        this.$message.error('操作失败')
      } finally {
        this.assignLoading = false
      }
    },

    // ==================== 建店资料弹窗 ====================
    async showDataCollect (row) {
      const instanceId = row.accountCreateNode?.instanceId || row.assignOperatorNode?.instanceId
      if (!instanceId) return

      // 保存实例ID用于后续保存操作
      this.currentDataCollectInstanceId = instanceId

      try {
        const { data: res } = await this.$http.get(`process/instances/${instanceId}`, {
          params: { includeLogs: false }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

        // 从节点中找到 DATA_COLLECT 节点
        const dataCollectNode = (res.data.nodes || []).find(n => n.code === 'DATA_COLLECT')
        if (!dataCollectNode) {
          return this.$message.warning('该流程暂无建店资料')
        }

        this.dataCollectData = {
          projectName: res.data.instance?.projectName || '',
          customerName: res.data.instance?.projectId?.customerName || '',
          ...dataCollectNode.data
        }

        // 初始化地址编辑表单
        this.addressEditForm = {
          storeAddress: dataCollectNode.data?.storeAddress || '',
          lat: dataCollectNode.data?.lat || 0,
          lng: dataCollectNode.data?.lng || 0,
          province: dataCollectNode.data?.province || '',
          city: dataCollectNode.data?.city || '',
          district: dataCollectNode.data?.district || ''
        }

        this.dataCollectDialogVisible = true
      } catch (error) {
        console.error('获取建店资料失败:', error)
        this.$message.error('获取建店资料失败')
      }
    },

    // 图片批量下载
    async handleDownloadImages () {
      if (!this.dataCollectData.images || this.dataCollectData.images.length === 0) {
        return this.$message.warning('暂无图片可下载')
      }

      this.downloadLoading = true
      try {
        const response = await this.$http.post('process/download-images',
          { images: this.dataCollectData.images },
          { responseType: 'blob' }
        )

        const data = response.data

        // 检查是否返回了错误信息（后端用 ctx.returnRes 返回 JSON）
        if (data.type === 'application/json') {
          // 将 blob 转换为文本解析错误信息
          const text = await data.text()
          const errorData = JSON.parse(text)
          return this.$message.error(errorData.meta?.msg || '下载失败')
        }

        // 创建 Blob 下载链接，指定正确的 MIME 类型
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }))
        const link = document.createElement('a')
        link.href = url
        const projectName = this.dataCollectData.projectName || '建店资料'
        link.setAttribute('download', `${projectName}_图片.zip`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载图片失败:', error)
        this.$message.error('下载图片失败')
      } finally {
        this.downloadLoading = false
      }
    },

    // ==================== 地图 ====================
    loadScript () {
      this.scriptLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      window.removeJiandianLoading = () => { this.scriptLoading.close() }
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${ChoujianMap.apiKey}&callback=removeJiandianLoading`
      document.body.appendChild(script)
      this.script = script
    },

    addEditableMap () {
      const lat = this.addressEditForm.lat || 34.309615
      const lng = this.addressEditForm.lng || 108.923302

      // 初始化可交互地图（interactive=true）
      this.map = new ChoujianMap('jiandian-map-container', lat, lng, true)
      this.map.addPoint(lat, lng)

      // 监听地图点击事件，更新坐标
      this.map.on('click', (lat, lng) => {
        this.addressEditForm.lat = lat
        this.addressEditForm.lng = lng
      })
    },

    // 自动定位
    async autoLocateForEdit () {
      const address = this.addressEditForm.storeAddress
      if (!address) {
        this.$message.warning('请先输入门店地址')
        return
      }
      try {
        const { data: res } = await this.$http.get('map/geocoder', { params: { address } })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

        // 更新坐标和行政区划信息
        this.addressEditForm.lat = res.data.location.lat
        this.addressEditForm.lng = res.data.location.lng
        this.addressEditForm.province = res.data.address_components.province
        this.addressEditForm.city = res.data.address_components.city
        this.addressEditForm.district = res.data.address_components.district

        // 更新地图标注点位置
        this.map.setPoint(res.data.location.lat, res.data.location.lng)
        this.$message.success('定位成功')
      } catch (error) {
        console.error('自动定位失败:', error)
        this.$message.error('自动定位失败')
      }
    },

    // 保存地址定位修改
    async saveAddressEdit () {
      const { storeAddress, lat, lng } = this.addressEditForm
      if (!storeAddress) {
        return this.$message.warning('请输入门店地址')
      }
      if (!lat || !lng) {
        return this.$message.warning('请先进行定位')
      }

      this.addressEditLoading = true
      try {
        const { data: res } = await this.$http.put(`process/instances/${this.currentDataCollectInstanceId}/dataCollectAddress`, {
          storeAddress: this.addressEditForm.storeAddress,
          lat: this.addressEditForm.lat,
          lng: this.addressEditForm.lng,
          province: this.addressEditForm.province,
          city: this.addressEditForm.city,
          district: this.addressEditForm.district
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

        // 更新本地数据
        this.dataCollectData.storeAddress = this.addressEditForm.storeAddress
        this.dataCollectData.lat = this.addressEditForm.lat
        this.dataCollectData.lng = this.addressEditForm.lng
        this.dataCollectData.province = this.addressEditForm.province
        this.dataCollectData.city = this.addressEditForm.city
        this.dataCollectData.district = this.addressEditForm.district

        this.$message.success('地址定位已更新')
      } catch (error) {
        console.error('保存地址定位失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.addressEditLoading = false
      }
    },

    removeMap () {
      if (this.map) {
        this.map.removeAllListeners('click')
        this.map.destroy()
        this.map = null
      }
    },

    unloadScript () {
      if (this.script) {
        document.body.removeChild(this.script)
        this.script = null
        this.map = null
        delete window.TMap
        delete window.removeJiandianLoading
      }
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-row {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.stat-card {
  flex: 1;
  border-radius: 8px;

  /deep/ .el-card__body {
    padding: 16px 20px;
  }
}

.stat-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;

  .platform-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  .platform-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

.stat-card-body {
  display: flex;
  justify-content: space-around;
}

.stat-item {
  text-align: center;

  .stat-value {
    display: block;
    font-size: 28px;
    font-weight: bold;
    color: #409eff;

    &.completed { color: #67c23a; }
    &.uncompleted { color: #e63c3c; }
  }

  .stat-label {
    display: block;
    font-size: 13px;
    color: #909399;
    margin-top: 4px;
  }
}

.search-bar {
  margin-bottom: 15px;
}

.el-pagination {
  margin-top: 15px;
}

.account-tip {
  color: #e6a23c;
  font-size: 13px;
  margin-bottom: 12px;
}

.account-form {
  .account-section {
    margin-bottom: 20px;
    padding: 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;

    .account-section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      font-weight: 600;

      .platform-icon-sm {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }

      .required-tag {
        font-size: 12px;
        color: #f56c6c;
        font-weight: normal;
      }

      .optional-tag {
        font-size: 12px;
        color: #909399;
        font-weight: normal;
      }

      .fill-project-name-btn {
        margin-left: auto;
        padding: 0;
        font-size: 12px;
      }
    }
  }
}

// 建店资料弹框 - 紧凑布局样式
.compact-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;

  .compact-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid #ebeef5;

    i { color: #409eff; font-size: 14px; }
    .edit-tag {
      font-size: 11px;
      color: #e6a23c;
      background: #fdf6ec;
      padding: 1px 6px;
      border-radius: 8px;
      border: 1px solid #e6a23c;
    }
    .img-count {
      font-size: 11px;
      color: #909399;
      margin-left: auto;
    }
  }

  .compact-row {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;

    &.coords {
      color: #909399;
      font-size: 11px;
      margin-bottom: 4px;
    }
  }

  .compact-item {
    display: flex;
    align-items: center;
    .label { color: #909399; }
    .coords-text { color: #409eff; }
  }

  .compact-images {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .compact-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
}

.compact-section.editable {
  border-color: #409eff;
  background: linear-gradient(to right, #ecf5ff, #fff);
}

.image-preview-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.text-title {
  font-size: 14px;
  font-weight: bold;
  color: #191a1a;
}

.text-detail {
  font-size: 12px;
  color: #909399;
}

.map-info {
  padding: 10px 15px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #606266;
}

.map-container {
  width: 100%;
  height: 450px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
</style>
